<main class="loginBannerBg" role="main">
    <h1 class="cdk-visually-hidden">Log in to Virtual Memory Box</h1>
    <div class="container d-flex justify-content-center">
        <div class="d-flex flex-column">
            <div>
                @if (view == 'construction') {
                    <mat-card class="mat-elevation-z0">
                        <template [ngTemplateOutlet]="logos"></template>
                        <mat-card-content>
                            @if (this.dynamicSettings?.under_construction && this.dynamicSettings?.under_construction_message) {
                                <div class="constructionText">
                                    <p>{{ this.dynamicSettings?.under_construction_message }}</p>
                                </div>
                            }
                            <div class="d-flex flex-col justify-content-center align-items-center">
                                <img ngSrc="assets/images/construction.png" width="350" height="337" alt="">
                            </div>
                            @if (!this.dynamicSettings?.logins_disabled_for_all_users) {
                                <div class="d-flex justify-content-center mt-10">
                                    <button (click)="this.view = 'Login'" (keyup.enter)="this.view = 'Login'"
                                            mat-raised-button color="primary"
                                            type="button">
                                        {{ this.dynamicSettings?.logins_disabled_for_non_admins ? 'Admin Login' : 'Login' }}
                                    </button>
                                </div>
                            }
                        </mat-card-content>
                    </mat-card>

                } @else if (view == 'Login') {
                    <mat-card class="mat-elevation-z0">
                        <template [ngTemplateOutlet]="logos"></template>
                        @if (this.dynamicSettings?.under_construction && this.dynamicSettings?.under_construction_message) {
                            <div class="constructionText">
                                <p>{{ this.dynamicSettings?.under_construction_message }}</p>
                            </div>
                        }
                        <mat-card-content>
                            <form [formGroup]="loginForm" class="d-flex flex-col">
                                <mat-form-field appearance="outline" class="mb-10" color="primary">
                                    <mat-label>Username</mat-label>
                                    <input (keyup.enter)="passwordField.focus()" autocapitalize="none"
                                           autocomplete="username" autocorrect="off" name="username"
                                           formControlName="username"
                                           matInput required
                                           spellcheck="false" type="text"/>
                                    @if (loginForm.controls['username'].hasError('required')) {
                                        <mat-error>
                                            This field is required
                                        </mat-error>
                                    }
                                    @if (loginForm.controls['username'].hasError('pattern')) {
                                        <mat-error>
                                            No spaces allowed in this field
                                        </mat-error>
                                    }
                                    @if (loginForm.value.username.includes('@')) {
                                        <mat-hint>
                                            Please enter username not email address
                                        </mat-hint>
                                    }

                                </mat-form-field>
                                <mat-form-field appearance="outline" color="primary">
                                    <mat-label>Password</mat-label>
                                    <input #passwordField (keyup.enter)="loginIfValid(loginForm.invalid || loading)"
                                           [type]="passwordType" autocomplete="current-password"
                                           name="password" formControlName="password" matInput
                                           required/>
                                    <button (click)="showPassword()" (keyup.enter)="showPassword()"
                                            [attr.aria-label]="passwordType == 'password' ? 'Show Password' : 'Hide Password'"
                                            [matTooltip]="passwordType == 'password' ? 'Show Password' : 'Hide Password'"
                                            class="h-fit-content p0" mat-icon-button
                                            matSuffix
                                            type="button">
                                        @if (passwordType == 'password') {
                                            <mat-icon color="primary">remove_red_eye
                                            </mat-icon>
                                        }
                                        @if (passwordType == 'text') {
                                            <mat-icon color="primary">highlight_off</mat-icon>
                                        }
                                    </button>
                                    @if (loginForm.controls['password'].hasError('required')) {
                                        <mat-error>
                                            This field is required
                                        </mat-error>
                                    }
                                </mat-form-field>
                                <div class="justify-content-center flex-col">
                                    <button (click)="this.view = 'Email'" (keyup.enter)="this.view = 'Email'"
                                            class="w-content mx-auto" mat-button
                                            type="button">
                                        <small>Forgot Username?</small>
                                    </button>
                                    <button (click)="this.view = 'Forgot'" (keyup.enter)="this.view = 'Forgot'"
                                            class="w-content mx-auto" mat-button
                                            type="button">
                                        <small>Forgot Password?</small>
                                    </button>
                                </div>
                            </form>
                        </mat-card-content>
                        <mat-card-actions class="text-center">
                            <button (click)="login()" [attr.aria-busy]="loading"
                                    [disabled]="loginForm.invalid || loading"
                                    class="mx-auto my-10"
                                    color="primary" mat-flat-button type="submit">
                                Login
                                @if (loading) {
                                    <mat-spinner [diameter]="24" aria-label="Logging in" class="ms-2"></mat-spinner>
                                }
                            </button>
                        </mat-card-actions>
                        @if (showAzureSignInButton) {
                            <div class="flex-row align-items-center">
                                <hr class="w-100 h-fit mx-10">
                                <p class="year">Or</p>
                                <hr class="w-100 h-fit mx-10">
                            </div>
                            <div class="justify-content-center flex-col align-items-center">
                                <button (click)="azureSignin()" [attr.aria-busy]="directoryLoading"
                                        [disabled]="directoryLoading" aria-label="Redirect to sign in with Microsoft"
                                        class="w-content mx-10 azure"
                                        type="button">
                                    <mat-icon aria-hidden="true" svgIcon="activeDirectory"></mat-icon>
                                    @if (directoryLoading) {
                                        <mat-spinner [diameter]="24" aria-label="Redirecting"
                                                     class="ms-2"></mat-spinner>
                                    }
                                    Sign in with Microsoft
                                </button>
                            </div>
                        }
                        <div class="p-10">
                            @if (this.dynamicSettings?.login_support_text_rendered) {
                                <div [innerHTML]="this.dynamicSettings?.login_support_text_rendered"
                                     aria-label="Login support information" class="f-12 text-center"
                                     role="note"></div>
                            }
                        </div>
                    </mat-card>
                }
                @if (view == 'Email') {
                    <mat-card>
                        <template [ngTemplateOutlet]="logos"></template>
                        <mat-card-content>
                            <form [formGroup]="requestUsernameForm">
                                <mat-form-field appearance="outline" class="w-100" color="primary">
                                    <mat-label>Email</mat-label>
                                    <input (keyup.enter)="usernameRequestIfValid(requestUsernameForm.invalid)"
                                           autocomplete="email" name="email" formControlName="email" matInput required type="email"/>
                                    @if (requestUsernameForm.controls['email'].hasError('required')) {
                                        <mat-error>
                                            This field is required
                                        </mat-error>
                                    }
                                    @if (requestUsernameForm.controls['email'].hasError('email')) {
                                        <mat-error>
                                            Please enter a valid email address
                                        </mat-error>
                                    }
                                </mat-form-field>
                                <div class="d-flex justify-content-center">
                                    <button (click)="this.view = 'Login'" (keyup.enter)="this.view = 'Login'" mat-button
                                            type="button">
                                        <small>Remembered Your Username?</small>
                                    </button>
                                </div>
                            </form>
                        </mat-card-content>
                        <mat-card-actions class="text-center">
                            <button (click)="usernameRequest()" (keyup.enter)="usernameRequest()"
                                    [attr.aria-busy]="loading"
                                    [disabled]="requestUsernameForm.invalid || loading"
                                    class="mx-auto my-10"
                                    color="primary"
                                    mat-flat-button type="submit">
                                Send email with associated usernames
                                @if (loading) {
                                    <mat-spinner [diameter]="24" aria-label="Sending" class="ms-2"></mat-spinner>
                                }
                            </button>
                        </mat-card-actions>
                        <div class="p-10">
                            @if (this.dynamicSettings?.login_support_text_rendered) {
                                <div [innerHTML]="this.dynamicSettings?.login_support_text_rendered"
                                     aria-label="Login support information" class="f-12 text-center"
                                     role="note"></div>
                            }
                        </div>
                    </mat-card>
                }
                @if (view == 'Forgot') {
                    <mat-card>
                        <template [ngTemplateOutlet]="logos"></template>
                        <mat-card-content>
                            <form [formGroup]="requestPasswordForm">
                                <p>Enter the email address associated with your account(s).</p>
                                <mat-form-field appearance="outline" class="w-100" color="primary">
                                    <mat-label>Email address</mat-label>
                                    <input (keyup.enter)="passwordResetRequestIfValid(requestPasswordForm.invalid)"
                                           autocapitalize="none" autocomplete="email" autocorrect="off"
                                           name="email" formControlName="email" matInput required spellcheck="false"
                                           type="email"/>
                                    @if (requestPasswordForm.controls['email'].hasError('required')) {
                                        <mat-error>
                                            This field is required
                                        </mat-error>
                                    }
                                    @if (requestPasswordForm.controls['email'].hasError('email')) {
                                        <mat-error>
                                            Please enter a valid email address
                                        </mat-error>
                                    }
                                </mat-form-field>
                                <div class="d-flex justify-content-center">
                                    <button (click)="this.view = 'Login'" (keyup.enter)="this.view = 'Login'" mat-button
                                            type="button">
                                        <small>Remembered Your Password?</small>
                                    </button>
                                </div>
                            </form>
                        </mat-card-content>
                        <mat-card-actions class="text-center">
                            <button (click)="passwordResetRequest()" (keyup.enter)="passwordResetRequest()"
                                    [attr.aria-busy]="loading"
                                    [disabled]="requestPasswordForm.invalid || loading"
                                    class="mx-auto my-10"
                                    color="primary"
                                    mat-flat-button type="submit">
                                Recover Password
                                @if (loading) {
                                    <mat-spinner [diameter]="24" aria-label="Sending" class="ms-2"></mat-spinner>
                                }
                            </button>
                        </mat-card-actions>
                        <div class="p-10">
                            @if (this.dynamicSettings?.login_support_text_rendered) {
                                <div [innerHTML]="this.dynamicSettings?.login_support_text_rendered"
                                     aria-label="Login support information" class="f-12 text-center"
                                     role="note"></div>
                            }
                        </div>
                    </mat-card>
                }
                @if (view == 'Code') {
                    <mat-card>
                        <template [ngTemplateOutlet]="logos"></template>
                        <mat-card-header>
                            <mat-card-title class="pb-10">A code has been sent to {{ sentTo?.email }}
                                @if (sentTo && sentTo?.secondary_email) {
                                    and {{ sentTo.secondary_email }}
                                }
                            </mat-card-title>
                        </mat-card-header>
                        <mat-card-content>
                            <form [formGroup]="otpForm">
                                <mat-form-field appearance="outline" class="w-100" color="primary">
                                    <mat-label>Code</mat-label>
                                    <input (keyup.enter)="finishLoginIfValid(otpForm.invalid)"
                                           autocomplete="one-time-code"
                                           formControlName="code" matInput
                                           required type="text"/>
                                    @if (otpForm.controls['code'].hasError('required')) {
                                        <mat-error>
                                            This field is required
                                        </mat-error>
                                    }
                                </mat-form-field>
                            </form>
                            <small>
                                Codes may take 1-2 minutes to arrive, please wait at least 30 secs before requesting a
                                new one.
                            </small>
                        </mat-card-content>
                        <mat-card-actions class="text-center flex-row flex-space-around">
                            <div>
                                @if (!timer) {
                                    <button (click)="request2fa()" (keyup.enter)="request2fa()"
                                            [disabled]="loading || timer > 0"
                                            class="mx-auto my-10 mx-10"
                                            color="accent" mat-flat-button type="button">
                                        @if (timer) {
                                            Code request available again in {{ timer }} seconds
                                        }
                                        @if (!timer) {
                                            Re-Send Code
                                        }
                                    </button>
                                }
                            </div>
                            <button (click)="finishLogin()" (keyup.enter)="finishLogin()"
                                    [attr.aria-busy]="loading"
                                    [disabled]="otpForm.invalid || loading"
                                    class="mx-auto my-10 mx-10"
                                    color="primary" mat-flat-button type="submit">
                                Continue
                                @if (loading) {
                                    <mat-spinner [diameter]="24" aria-label="Verifying" class="ms-2"></mat-spinner>
                                }
                            </button>
                        </mat-card-actions>
                        <div class="p-10">
                            @if (this.dynamicSettings?.login_support_text_rendered) {
                                <div [innerHTML]="this.dynamicSettings?.login_support_text_rendered"
                                     aria-label="Login support information" class="f-12 text-center loginText"
                                     role="note"></div>
                            }
                        </div>
                    </mat-card>
                }
            </div>
        </div>
    </div>
</main>
<app-footer></app-footer>

<ng-template #logos>
    <div class="col-row logosGrid">
        <img alt="Virtual Memory Box Logo" class="my-10 logo"
             src="assets/images/vmb.png">
        @if (this.dynamicSettings?.authority_logo) {
            <img [alt]=" this.dynamicSettings?.authority_name + ' Logo'" [src]="this.dynamicSettings?.authority_logo"
                 class="my-10 logo">
        }
    </div>
</ng-template>
